<span class="uptime-timer">
  {{ display() }}
</span>
